import { render, staticRenderFns } from "./SimplePrice.vue?vue&type=template&id=678f93da&scoped=true"
import script from "./SimplePrice.vue?vue&type=script&lang=js"
export * from "./SimplePrice.vue?vue&type=script&lang=js"
import style0 from "./SimplePrice.vue?vue&type=style&index=0&id=678f93da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f93da",
  null
  
)

export default component.exports